import { render, staticRenderFns } from "./TemplateFullFrameNew.vue?vue&type=template&id=fa59c93c&scoped=true&"
import script from "./TemplateFullFrameNew.vue?vue&type=script&lang=js&"
export * from "./TemplateFullFrameNew.vue?vue&type=script&lang=js&"
import style0 from "./TemplateFullFrameNew.vue?vue&type=style&index=0&id=fa59c93c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa59c93c",
  null
  
)

export default component.exports